import React from 'react'

function TenderTextCircul() {
    return (
        <embed src="\pdfs\EAT1.4.2.1_Q-Z_Circular_displacement_outlet_kr.pdf" width="100%" height="2100px" />
    )
}

export default TenderTextCircul